import React, {useContext, useEffect, useMemo, useRef, useState} from 'react';
import {AgGridReact} from "ag-grid-react";
import DevicesActionsCellRenderer from "./devices-actions-cell-renderer.jsx";
import DevicesAppCellRenderer from "./devices-app-cell-renderer.jsx";
import DevicesConfigModal from "./devices-config-modal.jsx";
import {AgentContext} from "../../../context/agent-context.jsx";
import {FaCheck, FaPlus} from "react-icons/fa";
import projectUtils from "../../../../../../../utils/project-utils.js";
import AlertMessages from "../../../../../../../components/messages/alert-message.js";
import {Card} from "../../../../../../../components/card/card.jsx";
import aggridUtils from "../../../../../../../utils/aggrid-utils.js";
import Button from "../../../../../../../components/button/button.jsx";
import {Modal} from "../../../../../../../components/modal/modal.jsx";
import SelectComponent from "../../../../../../../components/select/select-component.jsx";
import InputForm from "../../../../../../../components/input/input-form.jsx";
import optionsUtils from "../../../../../../../utils/options-utils.js";
import deviceService from "../../../../../../../services/web/device-service.js";

const initialData = {
    id: null,
    type: "",
    phone: "",
    description: "",

    abordagemAuthorized: false,
    abordagemDtActivation: "",
    monitoramentoAuthorized: false,
    monitoramentoDtActivation: "",
    despachoAuthorized: false,
    despachoDtActivation: "",
    pclAuthorized: "",
    pclDtActivation: false,
    agentAuthorized: "",
    agentDtActivation: false,
}

const UserDevices = () => {
    const {id, lanes, setDevices, setShared, devices, user, setChanges, tabs} = useContext(AgentContext);
    const [openDeviceConfig, setOpenDeviceConfig] = useState(false);
    const [open, setOpen] = useState(false);
    const [deviceSelected, setDeviceSelected] = useState(undefined);
    const [data, setData] = useState(initialData)

    const gridRef = useRef();

    const [columnDefs, ] = useState([
        {
            headerName: "Principal",
            field: "main",
            width: 100,
            sortable: false,
            cellRenderer: ({value}) => {
                if (value) {
                    return (
                        <div className={"flex items-center justify-center h-full w-full"}>
                            <FaCheck color={"#198754"} />
                        </div>
                    );
                }
            },
        },
        {headerName: "Tipo", field: "type", width: 200},
        {headerName: "Número", field: "phone", width: 140, valueFormatter: ({value}) => projectUtils.formatPhone(value)},
        {headerName: "Descrição", field: "description", flex: 1, minWidth: 200},
        {
            headerName: "App Agente",
            field: "",
            sortable: false,
            width: 125,
            cellRenderer: DevicesAppCellRenderer,
            cellRendererParams: ({data}) => ({
                authorized: data.agentAuthorized,
                dt_activation: data.agentDtActivation,
            })
        },
        {
            headerName: "App Alarmes",
            field: "",
            sortable: false,
            width: 125,
            cellRenderer: DevicesAppCellRenderer,
            cellRendererParams: ({data}) => ({
                authorized: data.monitoramentoAuthorized,
                dt_activation: data.monitoramentoDtActivation,
            })
        },
        {
            headerName: "App Despacho",
            field: "",
            sortable: false,
            width: 125,
            cellRenderer: DevicesAppCellRenderer,
            cellRendererParams: ({data}) => ({
                authorized: data.despachoAuthorized,
                dt_activation: data.despachoDtActivation,
            })
        },
        {
            headerName: "App Captura",
            field: "",
            sortable: false,
            width: 125,
            cellRenderer: DevicesAppCellRenderer,
            cellRendererParams: ({data}) => ({
                authorized: data.pclAuthorized,
                dt_activation: data.pclDtActivation,
            })
        },
        {
            headerName: "",
            field: "",
            width: 100,
            sortable: false,
            cellRenderer: DevicesActionsCellRenderer,
            cellRendererParams: {setOpen: setOpenDeviceConfig, setDeviceSelected, setDevices, setShared, tabs, setChanges, remove: true}
        },
    ]);

    const defaultColDef = useMemo(
        () => ({
            resizable: false,
        }), []
    );

    const handleInputs = (element) => {
        const {value, id} = element.target;
        setData(prev => ({...prev, [id]: value}));
    };

    const save = async () => {
        const verify = await validateDevice();

        if (!verify) return;

        const device = {
            type: data.type,
            phone: data.phone.replace(/\D/g, ""),
            description: data.description
        }

        setDevices([...devices, device]);
        setChanges('devices');
        onHide()
    }

    const validateDevice = async () => {
        if (!data.type || !data.phone) {
            projectUtils.swalMessage('warning', 'Atenção', AlertMessages["type.or.phone.is.empty"], 'Ok');
            return false;
        }

        if (data.phone.length < 10) {
            projectUtils.swalErrorMessage('', AlertMessages["incomplete.number"], 'Ok');
            return false;
        }

        if (data.type === "CELULAR" && await verifyIfDeviceAlreadyExist(data.phone)) {
            projectUtils.swalErrorMessage("", AlertMessages["number.already.exists"], "Ok");
            return false;
        }

        return true;
    }

    const verifyIfDeviceAlreadyExist = (phone) => deviceService.deviceExists(phone.replace(/\D/g, "")).then((data) => data.exists);

    const onHide = () => {
        setData(initialData);
        setOpen(false)
    }

    return (
        <>
            <Card>
                <Card.Header className={"gap-2"}>
                    <Card.Title>Telefones e APPs</Card.Title>
                    <Button className={"h-[30px] w-[30px] !p-0"}  onClick={() => setOpen(true)}>
                        <FaPlus />
                    </Button>
                </Card.Header>
                <Card.Body>
                    <div className={"h-[calc(100vh-196px)]"}>
                        <AgGridReact
                            ref={gridRef}
                            rowData={devices}
                            columnDefs={columnDefs}
                            // defaultColDef={defaultColDef}
                            animateRows={false}
                            suppressCellFocus={true}
                            gridOptions={{localeText: aggridUtils.localization()}}
                            theme={aggridUtils.generalTheme()}
                        />
                    </div>
                </Card.Body>
            </Card>

            <DevicesConfigModal
                devices={devices}
                setDevices={setDevices}
                deviceSelected={deviceSelected}
                open={openDeviceConfig}
                setOpen={setOpenDeviceConfig}
                lanes={lanes}
                user={user}
                userId={id}
            />

            <Modal isCloseClick={false} open={open} setOpen={onHide} centered size="xl" backdrop="static" keyboard={false} className={"w-3/12"}
                   title={"Adicionar telefone"} overflow={true}>
                <Modal.Body className="p-2">
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12">
                            <SelectComponent
                                id={"type"}
                                value={optionsUtils.typePhones.find(option => option.value === data.type)}
                                options={optionsUtils.typePhones}
                                label={"Tipo"}
                                onChange={(selected) => setData(prev => ({...prev, type: selected.value}))}
                            />
                        </div>

                        <div className="col-span-12">
                            <InputForm
                                id="phone"
                                value={data.phone}
                                label="Número"
                                onBlur={handleInputs}
                                onChange={handleInputs}
                                mask={[{ mask: "(00) 0000-0000" }, { mask: "(00) 00000-0000" }]}
                            />
                        </div>
                        <div className="col-span-12">
                            <InputForm id="description" value={data.description} label="Descrição" onChange={handleInputs}/>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className={"p-2"}>
                    <div className={"w-full flex justify-end"}>
                        <Button onClick={save}>
                            Confirmar
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default UserDevices;